// Couleurs pour les statuts des demandes
export const STATUS_COLORS = {
  completed: '#4CAF50', // Vert
  inProgress: '#2196F3', // Bleu
  pending: '#FFC107', // Jaune
  cancelled: '#9E9E9E', // Gris
};

// Couleurs pour les priorités des demandes
export const PRIORITY_COLORS = {
  urgent: '#F44336', // Rouge
  high: '#FF5722', // Orange foncé
  medium: '#FF9800', // Orange
  low: '#8BC34A', // Vert clair
};
